
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { moneyLog } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
list: [],
finished: false,
loading: false,
type: 2
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
onLoad() {
this.getData()
},
timeChange(time) {


if (typeof time === 'string' && time.includes('-')) {
return time;
}

var date = new Date(time*1000);
var Y = date.getFullYear() + '-';
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
var D = date.getDate() <10 ? '0'+date.getDate() + ' ' : date.getDate()+' ';
var h = date.getHours() + ':';
var m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes() ;
var s = date.getSeconds();
return Y+M+D+h+m;
},
getData(){
var that = this
this.$Loading()
moneyLog({token: this.token, subtype: this.type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.list =res.data || []
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch: {
type: {
handler(curVal, oldVal) {
this.getData()
},
deep: true
}
}
}



// WEBPACK FOOTER //
// ./src/pages/accountChange.vue